module.exports = __webpack_public_path__ + "img/履约保函.bba01d39.png";